import React from 'react';
import cn from '../../../../Utils/class-names.utils';

interface FormRowProps {
  label: string;
  htmlFor?: string;
  children: React.ReactNode;
  variant?: 'standard' | 'supplier' | 'withPadding' | 'fieldRow' | 'totalRow';
  className?: string;
  labelClassName?: string;
  labelIcon?: React.ReactNode;
  styles: Record<string, string>;
  containerProps?: React.HTMLAttributes<HTMLDivElement>;
  labelId?: string;
}

const FormRow: React.FC<FormRowProps> = ({
  label,
  htmlFor,
  children,
  variant = 'standard',
  className,
  labelClassName,
  labelIcon,
  styles: styleModule,
  containerProps,
  labelId,
}) => {
  if (variant === 'supplier') {
    return (
      <div className={cn(styleModule.supplierSection, className)}>
        <div className={styleModule.supplierLabelContainer}>
          <label className={cn(styleModule.supplierLabel, labelClassName)}>
            {label}
          </label>
        </div>
        {children}
      </div>
    );
  }

  if (variant === 'withPadding') {
    return (
      <div className={cn(styleModule.formFieldWithPadding, className)}>
        <div className={styleModule.labelContainer}>
          <label
            htmlFor={htmlFor}
            className={cn(styleModule.labelFlex, labelClassName)}
          >
            {label}
          </label>
          {labelIcon}
        </div>
        {children}
      </div>
    );
  }

  if (variant === 'fieldRow') {
    return (
      <div className={cn(styleModule.fieldRow, className)}>
        <div className={styleModule.labelContainer}>
          <label
            htmlFor={htmlFor}
            className={cn(styleModule.label, labelClassName)}
          >
            {label}
          </label>
        </div>
        {children}
      </div>
    );
  }

  if (variant === 'totalRow') {
    return (
      <div className={cn(styleModule.totalRow, className)} {...containerProps}>
        <div className={styleModule.totalLabelContainer}>
          <label
            id={labelId}
            htmlFor={htmlFor}
            className={cn(styleModule.labelBold, labelClassName)}
          >
            {label}
          </label>
        </div>
        {children}
      </div>
    );
  }

  return (
    <div className={cn(styleModule.formField, className)}>
      <label
        htmlFor={htmlFor}
        className={cn(styleModule.label, labelClassName)}
      >
        {label}
      </label>
      {children}
    </div>
  );
};

export default FormRow;

